module.exports = __webpack_public_path__ + "static/media/gift-10.1cb2c93d.jpg";